import {Localizer} from "../../../infrastructure/localization/localizer";
import React, {useState} from "react";
import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import {EmblaIcons} from "../../../core/emblaIcons";
import {RoutePaths} from "../../../infrastructure/routes";
import {useHistory} from "react-router-dom";
import DynamicButton from "../../../core/components/button/dynamicButton";

const MAX_VISIBLE = 3;

type VejlederCellProps = {
    vejledernames: string[];
}
export const VejlederCell = ({vejledernames}: VejlederCellProps) => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(false);

    const shouldShowBadge = vejledernames.length === 0 ||
        (vejledernames.length === 1 && vejledernames[0] === Localizer.dashboard_tildelVejleder());

    if (shouldShowBadge) {
        return (
            <div
                className="flex-align-c badge badge-danger-light badge-pill padding-xs clickable"
                onClick={() => history.push(RoutePaths.Vejledere.url)}>
                <div className={"flex-center margin-right-xs"}>
                    <EmblaIcon iconName={EmblaIcons.Danger} additionalClasses={"margin-right-xs danger"}
                               size={"medium"}/>
                    <b className={"danger-dark"}>
                        {Localizer.dashboard_tildelVejleder()}
                    </b>
                </div>
            </div>
        );
    }

    const hasMore = vejledernames.length > MAX_VISIBLE;
    const visibleNames = hasMore && !expanded ? vejledernames.slice(0, MAX_VISIBLE) : vejledernames;

    const rows: string[][] = [];
    for (let i = 0; i < visibleNames.length; i += MAX_VISIBLE) {
        rows.push(visibleNames.slice(i, i + MAX_VISIBLE));
    }

    return (
        <div className="d-flex flex-column">
            {rows.map((row, rowIndex) => (
                <span key={rowIndex}>{row.join(", ")}</span>
            ))}
            {hasMore && (
                <DynamicButton
                    additionalClasses="btn-link p-0 text-left align-self-start"
                    onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(prev => !prev);
                    }}
                >
                    {expanded ? Localizer.global_visFaerre() : Localizer.global_visFlere()}
                </DynamicButton>
            )}
        </div>
    );
};
